import { createSelector } from '@ngrx/store';

import {
  createEntityCollectionStore,
  memoizeSelector,
  ngrxEvent,
  pipeState,
} from '@core/ngrx-legacy';

import type {
  JobEvaluationFormsEntity,
  JobInterviewTemplate,
} from './job-evaluation-forms-store.types';
import { EntityStoreKey } from '../../types';

const {
  namespace,
  selectors: defaultSelectors,
  actions: defaultActions,
  reducer,
} = createEntityCollectionStore<JobEvaluationFormsEntity>()(EntityStoreKey.JobEvaluationForms, {
  idSelector: e => e.jobId,
  customActions: adapter => ({
    fetchOne: (state, payload: { jobId: number }) =>
      adapter.markAsPending(state, { scope: null, entities: [payload.jobId] }),
    fetchOneSuccess: (state, payload: { scope: null; data: JobEvaluationFormsEntity }) =>
      pipeState(adapter.upsertOne(state, payload.data), next =>
        adapter.markAsLoaded(next, { scope: null, entities: [payload.data.jobId] }),
      ),
    fetchOneFailed: ngrxEvent<{ jobId: number }>(),
  }),
});

const selectors = {
  byJobId: memoizeSelector((id: number) =>
    createSelector(
      defaultSelectors.byId(id),
      (state: JobEvaluationFormsEntity | null): JobInterviewTemplate[] | null =>
        state?.jobInterviewTemplates ?? null,
    ),
  ),
  meta: defaultSelectors.meta,
};

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

export {
  actions as JobEvaluationFormsActions,
  namespace as JobEvaluationFormsNamespace,
  selectors as JobEvaluationFormsSelectors,
  reducer as JobEvaluationFormsReducer,
};
